import { enableMapSet } from 'immer';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { apiGetUserBasicInfo } from '../api/user';

interface DisplayUserState {
  userInfo?: any;
}

interface DisplayUserActions {
  updateDisplayUserInfo: (data: any) => void;
}

interface DisplayUserStore {
  state: DisplayUserState;
  actions: DisplayUserActions;
}

enableMapSet();

export const displayUserStore = create<DisplayUserStore>()(
  immer((set, get) => ({
    state: {
      userInfo: null,
    },
    actions: {
      updateDisplayUserInfo: async (config: { userId: string }) => {
        const { userInfo } = get().state;

        const [res] = await apiGetUserBasicInfo({ id: config?.userId });
        if (res) {
          set((store) => {
            store.state.userInfo = {
              ...userInfo,
              ...res?.data?.user,
            };
          });
        }
      },
    },
  }))
);
